const NOTIFICATION_STATUSES = {
  overdue: 'Overdue',
  read: 'Read',
  unread: 'Unread',
} as const;

export default NOTIFICATION_STATUSES;
